<template>
    <charges-get
        :page="page"
        :archived="archived"
        :include="[
            'payee',
            'rents(paginate:1,2)',
            'fees(paginate:1,2)',
            'properties',
        ]"
        v-slot="{
            data: charges,
            meta,
            error,
            is_loading,
            has_loaded,
            get
        }"
    >
        <div v-if="!has_loaded || error">
            <base-loading
                :error="error"
                :retry="get"
                class="py-6"
            />

            <error-modal
                v-if="error"
                :error="error"
            />
        </div>

        <div v-else>
            <base-hint name="tenants-charges-index">
                <template slot="heading">
                    Payments
                </template>

                <p class="mb-3">
                    See all of your payments here, just like a bank statement.
                </p>

                <p>
                    At a glance you can also see important information associated with each payment, for example, the payee, tenancy and property.
                </p>
            </base-hint>

            <div class="mb-6 bg-white rounded shadow">
                <header class="flex items-center px-4 border-b h-18 sm:px-6">
                    <div class="flex-grow">
                        <h1 class="text-lg font-normal">Payments</h1>
                    </div>
                    <div class="w-6 h-6 mr-3">
                        <base-svg
                            v-show="is_loading"
                            name="icon-loading"
                            class="w-full h-full fill-current text-grey"
                        />
                    </div>
                </header>

                <template v-if="meta.count > 0">
                    <charges-list :charges="charges" />

                    <footer class="px-4 text-sm font-semibold rounded-b bg-grey-bg sm:px-6 text-grey-darker">
                        <base-pagination
                            v-model="page"
                            :per-page="meta.per_page"
                            :from="meta.from"
                            :to="meta.to"
                            :last-page="meta.last_page"
                            :count="meta.count"
                            :total="meta.total"
                            :is-disabled="is_loading"
                        />
                    </footer>
                </template>

                <div
                    v-else
                    class="py-16 border-t"
                >
                    <div class="max-w-sm px-6 mx-auto text-center">
                        <h2 class="mb-2 text-xl font-semibold">
                            No payments
                        </h2>

                        <div class="text-base text-grey-darker">
                            <p>You haven't made any payments yet.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </charges-get>
</template>

<script>
    import PaginationMixin from '../../../../mixins/pagination'
    import ChargesGet from '../../../../components/charges-get'
    import ChargesList from '../../../../components/charges-list'

    export default {
        mixins: [
            PaginationMixin
        ],
        components: {
            ChargesGet,
            ChargesList
        }
    }
</script>
